module.exports = __webpack_public_path__ + "img/3-1.b7d6930b.png";